var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.loading}},[[_c('div',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","xl":"6","md":"6"}},[_c('Update')],1),_c('b-col',[_c('MFA')],1)],1)],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }